import React from 'react';

import { QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

interface NoQualioDocFoundSelectProps {
  inputElement: { inputValue: string };
}

const NoQualioDocFoundSelect: React.FC<NoQualioDocFoundSelectProps> = ({ inputElement }) => {
  const { t } = useTranslation();

  if (!!inputElement.inputValue)
    return (
      <>
        <QText>{t('qualioDocSelect.noDocumentFound')}</QText>
        <QText fontWeight={'semibold'}>{inputElement.inputValue}</QText>
      </>
    );

  return <QText fontSize="sm">{t('qualioDocSelect.placeholder')}</QText>;
};

export default NoQualioDocFoundSelect;
